<template>
  <header class="header" :class="{ 'header-scrolled': isScrolled }">
    <!-- Top Bar -->
    <div class="top-bar" :class="{ 'hidden': isScrolled }">
      <div class="container">
        <div class="top-bar-content">
          <div class="contact-info">
            <span class="contact-item" :class="{ 'animate-in': mounted }">
              <i class="fas fa-phone mr-2 text-primary"></i>
              <a href="tel:+8615163903660">+86 15163903660</a>
            </span>
            <span class="contact-item" :class="{ 'animate-in': mounted }" style="transition-delay: 0.1s;">
              <i class="fas fa-envelope mr-2 text-primary"></i>
              <a href="mailto:postmaster5@lyyllb.com">postmaster5@lyyllb.com</a>
            </span>
            <span ref="langSwitcher" class="contact-item lang-switcher" :class="{ 'animate-in': mounted }" style="transition-delay: 0.2s;">
              <i class="fas fa-globe mr-2 text-primary"></i>
              <button class="lang-btn-inline" @click.stop="toggleLangMenu">
                <span>{{ currentLangName }}</span>
                <i class="fas fa-chevron-down ml-1"></i>
              </button>
              <transition name="dropdown">
                <div
                  v-if="showLangMenu"
                  class="lang-dropdown"
                  @click.stop
                >
                  <button class="lang-option" @click="switchLang('zh')" :class="{ active: $i18n.locale === 'zh' }">
                    <svg class="lang-flag" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg">
                      <rect fill="#de2910" width="30" height="20"/>
                      <path fill="#ffde00" d="M6.5 6.5L7.2 8.2L9 8.5L7.6 9.6L7.9 11.4L6.5 10.5L5.1 11.4L5.4 9.6L4 8.5L5.8 8.2Z"/>
                      <path fill="#ffde00" d="M11.5 4.5L11.8 5.3L12.7 5.4L12.1 6.1L12.2 7L11.5 6.5L10.8 7L10.9 6.1L10.3 5.4L11.2 5.3Z"/>
                      <path fill="#ffde00" d="M14.5 6.5L14.8 7.3L15.7 7.4L15.1 8.1L15.2 9L14.5 8.5L13.8 9L13.9 8.1L13.3 7.4L14.2 7.3Z"/>
                      <path fill="#ffde00" d="M14.5 9.5L14.8 10.3L15.7 10.4L15.1 11.1L15.2 12L14.5 11.5L13.8 12L13.9 11.1L13.3 10.4L14.2 10.3Z"/>
                      <path fill="#ffde00" d="M11.5 11.5L11.8 12.3L12.7 12.4L12.1 13.1L12.2 14L11.5 13.5L10.8 14L10.9 13.1L10.3 12.4L11.2 12.3Z"/>
                    </svg>
                    <span>{{ $t('lang.zh') }}</span>
                  </button>
                  <button class="lang-option" @click="switchLang('en')" :class="{ active: $i18n.locale === 'en' }">
                    <svg class="lang-flag" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg">
                      <rect fill="#b22234" width="30" height="20"/>
                      <rect fill="#fff" y="6.67" width="30" height="6.66"/>
                      <rect fill="#3c3b6e" y="13.33" width="30" height="6.67"/>
                      <rect fill="#fff" x="10" width="20" height="6.67"/>
                      <rect fill="#b22234" x="10" y="6.67" width="20" height="6.66"/>
                      <rect fill="#fff" x="10" y="13.33" width="20" height="6.67"/>
                    </svg>
                    <span>{{ $t('lang.en') }}</span>
                  </button>
                </div>
              </transition>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Navigation -->
    <nav class="navbar navbar-expand-lg" :class="{ 'compact': isScrolled }">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <div class="brand-icon">
            <img src="https://1500062809.vod-qcloud.com/6d053ea1vodcq1500062809/cefc037d5001834810594443328/JE36Y0C1bvQA.png" alt="Brand Logo">
          </div>
          <span class="brand-text">{{ $t('brand.name') }}</span>
        </router-link>

        <button class="navbar-toggler" type="button" @click="toggleMenu">
          <span class="hamburger" :class="{ 'is-active': isMenuOpen }">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <div class="navbar-collapse" :class="{ 'show': isMenuOpen }">
          <ul class="navbar-nav">
            <li class="nav-item" v-for="(item, index) in navItems" :key="item.path">
              <router-link
                class="nav-link"
                :to="item.path"
                :class="{ 'exact': item.exact }"
                :style="{ transitionDelay: isMenuOpen ? (index * 0.05) + 's' : '0s' }"
                @click="closeMenu"
              >
                <span class="nav-text">{{ $t(item.nameKey) }}</span>
                <span class="nav-indicator"></span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMenuOpen: false,
      showLangMenu: false,
      isScrolled: false,
      mounted: false,
      navItems: [
        { path: '/', nameKey: 'nav.home', exact: true },
        { path: '/about', nameKey: 'nav.about', exact: false },
        { path: '/products', nameKey: 'nav.products', exact: false },
        { path: '/news', nameKey: 'nav.news', exact: false },
        { path: '/contact', nameKey: 'nav.contact', exact: false }
      ]
    }
  },
  computed: {
    currentLangName() {
      return this.$t('lang.' + this.$i18n.locale)
    }
  },
  watch: {
    $route() {
      this.closeMenu()
    }
  },
  mounted() {
    setTimeout(() => {
      this.mounted = true
    }, 100)

    window.addEventListener('scroll', this.handleScroll, { passive: true })
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 80
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      if (this.isMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    closeMenu() {
      this.isMenuOpen = false
      document.body.style.overflow = ''
    },
    toggleLangMenu() {
      this.showLangMenu = !this.showLangMenu
    },
    switchLang(lang) {
      this.$i18n.locale = lang
      this.showLangMenu = false
    },
    handleClickOutside(event) {
      const langSwitcher = this.$refs.langSwitcher
      if (langSwitcher && langSwitcher.contains(event.target)) return
      this.showLangMenu = false
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0);
}

.header-scrolled {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.header-scrolled .top-bar {
  height: 0;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}

.header-scrolled .navbar {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 60px;
}

.header-scrolled .navbar-brand {
  padding: 10px 0;
}

.header-scrolled .brand-icon {
  width: 36px;
  height: 36px;
  font-size: 1.2rem;
}

/* Top Bar */
.top-bar {
  background-color: #f8f9fa;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  transition: all 0.4s ease;
}

.contact-info {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  align-items: center;
}

.contact-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.5s ease;
  position: relative;
}

/* Keep contact-row above the navbar so the dropdown isn't clipped/covered */
.contact-info,
.contact-item.lang-switcher {
  z-index: 10;
}

.contact-item.lang-switcher {
  position: relative;
}

.contact-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.contact-item a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-item a:hover {
  color: #e53935;
}

.text-primary {
  color: #e53935 !important;
}

/* Language Switcher (inline with contact items) */
.contact-item.lang-switcher {
  opacity: 0;
  transform: translateY(-10px);
}

.contact-item.lang-switcher.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.lang-btn-inline {
  background: none;
  border: none;
  padding: 0;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: color 0.3s ease;
}

.lang-btn-inline:hover {
  color: #e53935;
}

.lang-btn-inline .fa-chevron-down {
  font-size: 9px;
  transition: transform 0.3s ease;
}

/* Dropdown Animation */
.dropdown-enter {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
}

.dropdown-enter-active {
  opacity: 1;
  transform: translateY(0) scale(1);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-leave-active {
  opacity: 0;
  transform: translateY(-5px) scale(0.98);
  transition: all 0.2s ease;
}

.lang-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #fff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  z-index: 1100;
  overflow: hidden;
  padding: 8px 0;
}

.lang-flag {
  width: 22px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
}

.lang-option {
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.lang-option:hover {
  background-color: #fff5f5;
  color: #e53935;
}

.lang-option.active {
  background-color: #fff5f5;
  color: #e53935;
  font-weight: 500;
}

.lang-option .lang-flag {
  width: 22px;
  height: 22px;
}

/* Navbar */
.navbar {
  padding: 15px 0;
  min-height: 70px;
  display: flex;
  align-items: center;
  transition: all 0.4s ease;
  background: #fff;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #333;
  font-size: 22px;
  font-weight: 700;
  padding: 15px 0;
  text-decoration: none;
}

.brand-icon {
  width: 45px;
  height: 45px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  overflow: hidden;
}

.brand-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.navbar-brand:hover .brand-icon {
  transform: rotate(10deg) scale(1.05);
  box-shadow: 0 6px 20px rgba(229, 57, 53, 0.4);
}

.brand-text {
  background: linear-gradient(135deg, #333, #555);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Nav Links */
.navbar-nav {
  display: flex;
  gap: 5px;
  align-items: center;
  margin-left: auto;
}

.nav-item {
  position: relative;
}

.nav-link {
  color: #555;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 20px;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}

.nav-text {
  position: relative;
  z-index: 1;
  transition: color 0.3s ease;
}

.nav-indicator {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #e53935, #ff6f00);
  border-radius: 3px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-link:hover {
  color: #e53935;
}

.nav-link:hover .nav-indicator {
  width: calc(100% - 40px);
}

.nav-link.router-link-active,
.nav-link.router-link-exact-active {
  color: #e53935;
}

.nav-link.router-link-active .nav-indicator,
.nav-link.router-link-exact-active .nav-indicator {
  width: calc(100% - 40px);
}

/* Hamburger */
.navbar-toggler {
  border: none;
  padding: 10px;
  background: none;
  cursor: pointer;
}

.hamburger {
  width: 28px;
  height: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hamburger span {
  display: block;
  width: 100%;
  height: 3px;
  background: #333;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.hamburger.is-active span:nth-child(1) {
  transform: translateY(8.5px) rotate(45deg);
}

.hamburger.is-active span:nth-child(2) {
  opacity: 0;
}

.hamburger.is-active span:nth-child(3) {
  transform: translateY(-8.5px) rotate(-45deg);
}

/* WhatsApp Button */
.navbar-actions {
  margin-left: 30px;
}

.whatsapp-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #25D366, #128C7E);
  color: white;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
}

.whatsapp-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
  color: white;
}

.whatsapp-btn i {
  font-size: 1.2rem;
}

/* Mobile Styles */
@media (max-width: 991px) {
  .navbar-collapse {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    padding: 100px 30px 30px;
    transform: translateX(100%);
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
  }

  .navbar-collapse.show {
    transform: translateX(0);
  }

  .navbar-nav {
    flex-direction: column;
    gap: 0;
    margin-left: 0;
  }

  .nav-link {
    padding: 18px 0;
    font-size: 18px;
    border-bottom: 1px solid #f0f0f0;
    transform: translateX(30px);
    opacity: 0;
    transition: all 0.4s ease;
  }

  .navbar-collapse.show .nav-link {
    transform: translateX(0);
    opacity: 1;
  }

  .nav-indicator {
    display: none;
  }

  .navbar-actions {
    margin-left: 0;
    margin-top: auto;
  }

  .whatsapp-btn {
    width: 100%;
    justify-content: center;
    padding: 15px;
  }

  .lang-switcher {
    position: static;
  }

  .contact-info {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 12px;
    font-size: 12px;
  }

  .contact-item {
    font-size: 12px;
  }

  .lang-btn-inline {
    font-size: 12px;
  }
}

@media (max-width: 767px) {
  .brand-text {
    font-size: 18px;
  }

  .brand-icon {
    width: 38px;
    height: 38px;
    font-size: 1.1rem;
  }
}
</style>
